import React from 'react';
import { html } from 'lit';
import { OmniIconComponent, OmniStyleComponent, OmniTileComponent, OmniToolbarComponent, OmniTableStickyComponent, OmniSearchComponent, OmniIconMenu, LoaderComponent, AccordionComponent, Utils, AlertMessagesService } from '../../../shared';
import '../../../styles/rfpPreview.css';
import { RfpService } from '../';
import { PlacementDetailsTableService, PlacementFilterComponent } from '../../placements';
import * as XLSX from "xlsx";

class RfpPreview extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      rfp: {},
      proposals: [],
      isProposeAll: true
    };
    this.modalRef = React.createRef();
  }
  
  placementList = [];

  /**
   * Fetches RFP details.
   * @param {string} rfpId - The ID of the RFP.
   * @returns {void}
   */
  getRfpDetails = (rfpId, isFetchProposals) => {
    this.setState({ spinnerCount: 1, loading: true });
    let campaignId = encodeURIComponent(this.props.campaignObj.id);
    let rfpAPI = RfpService.getRfpDetails(campaignId, rfpId);
    rfpAPI.then((response) => {
      let rfpList = response.rfp[0];
      this.setState({ rfp: rfpList, spinnerCount: 0, loading: false }, () => {
        if(isFetchProposals)
          this.fetchProposalDetails(rfpId);
        if (this.props.printPreview)
          this.openPrintPreview();
      });
    }).catch((error) => {
      AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.getRfpDetails(rfpId, isFetchProposals), title: 'RFP details API cannot be loaded', bodyMsgArr: []}]);
      this.setState({ spinnerCount: 0, loading: false });
    })
  }

  /**
   * Fetches proposal details.
   * @param {string} rfpId - The ID of the RFP.
   * @param {string} alertMessage - The alert message.
   * @returns {void}
  */ 
  fetchProposalDetails = (rfpId, alertMessage) => {
    this.setState({ spinnerCount: 1});
    let proposalAPI = RfpService.getProposalsDetails(this.props.campaignObj.id, rfpId);
    proposalAPI.then((response) => {
      let proposals = response;
      let proposalMap = {};
      this.placementList = [];
      let isProposedIds = [];
      for (let i = 0; i < proposals.length; i++) {
        this.placementList.push(proposals[i]);

        if(proposals[i].is_proposed === "true")
          isProposedIds.push(proposals[i].placements_id)
        
        let placementType = proposals[i].placement_type ? proposals[i].placement_type : 'Unassigned';
        let site = proposals[i].site ? proposals[i].site : 'Unassigned';
        if (!proposalMap[placementType]) {
          proposalMap[placementType] = { 'nestedData': [], channelTotalUnit: 0, channelTotalCost: 0 };
          proposalMap[placementType][site] = { 'nestedData': [], totalUnit: [0], totalCost: [0] };
          proposalMap[placementType][site].nestedData.push(proposals[i]);
          if (!['Child', 'DSP'].includes(proposals[i].package_type)) {
            proposalMap[placementType][site].totalUnit[0] += Number(proposals[i].unit_amount);
            proposalMap[placementType][site].totalCost[0] += Number(proposals[i].planned_cost);
            proposalMap[placementType].channelTotalUnit += Number(proposals[i].unit_amount);
            proposalMap[placementType].channelTotalCost += Number(proposals[i].planned_cost);
          }
          proposalMap[placementType].nestedData.push({
            '_uniqueId': proposalMap[placementType].nestedData.length,
            'placement_taxonomy': site,
            'unit_amount': proposalMap[placementType][site].totalUnit,
            'planned_cost': proposalMap[placementType][site].totalCost,
            'nestedData': proposalMap[placementType][site].nestedData
          });
        } else {
          if (!proposalMap[placementType][site]) {
            proposalMap[placementType][site] = { 'nestedData': [], totalUnit: [0], totalCost: [0] };
            proposalMap[placementType][site].nestedData.push(proposals[i]);
            if (!['Child', 'DSP'].includes(proposals[i].package_type)) {
              proposalMap[placementType][site].totalUnit[0] += Number(proposals[i].unit_amount);
              proposalMap[placementType][site].totalCost[0] += Number(proposals[i].planned_cost);
              proposalMap[placementType].channelTotalUnit += Number(proposals[i].unit_amount);
              proposalMap[placementType].channelTotalCost += Number(proposals[i].planned_cost);
            }
            proposalMap[placementType].nestedData.push({
              '_uniqueId': proposalMap[placementType].nestedData.length,
              'placement_taxonomy': site,
              'unit_amount': proposalMap[placementType][site].totalUnit,
              'planned_cost': proposalMap[placementType][site].totalCost,
              'nestedData': proposalMap[placementType][site].nestedData
            });
          } else {
            proposalMap[placementType][site].nestedData.push(proposals[i]);
            if (!['Child', 'DSP'].includes(proposals[i].package_type)) {
              proposalMap[placementType][site].totalUnit[0] += Number(proposals[i].unit_amount);
              proposalMap[placementType][site].totalCost[0] += Number(proposals[i].planned_cost);
              proposalMap[placementType].channelTotalUnit += Number(proposals[i].unit_amount);
              proposalMap[placementType].channelTotalCost += Number(proposals[i].planned_cost);
            }
          }
        }
      }

      if(this.placementList.length === isProposedIds.length)
        this.setState({isProposeAll: false});
      else
        this.setState({isProposeAll: true});

      let finalProposalArr = [];
      for (let key in proposalMap) {
        finalProposalArr.push({
          _uniqueId: key,
          placement_taxonomy: key,
          nestedData: proposalMap[key].nestedData,
          unit_amount: proposalMap[key].channelTotalUnit,
          planned_cost: proposalMap[key].channelTotalCost
        })
      }

      this.setState({proposals: finalProposalArr, spinnerCount: 0}, () => {
        if(alertMessage)
          AlertMessagesService.showSuccessToastMessage(alertMessage);
        this.addFileUploadEventHandler();
      });
    }).catch((error) => {
      AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.fetchProposalDetails(rfpId, alertMessage), title: 'Proposals details API cannot be loaded', bodyMsgArr: []}]);
      this.setState({ spinnerCount: 0});
    })
  };

  /**
   * Opens the print preview mode for the current page.
   * @returns {void}
   */
  openPrintPreview = () => {
    document.body.classList.add('no-print')
    this.modalRef.current?.classList.add('print-preview')
    window.print()
  }

  // Lifecycle methods
  componentDidMount() {
    if (this.props?.rfp?.id) {
      this.getRfpDetails(this.props.rfp.id, true);
    }
  }

  // Lifecycle methods
  componentDidUpdate(prevProps, prevState) {
    if (this.props.rfp.id !== prevProps.rfp.id) {
      this.getRfpDetails(this.props.rfp.id, true);
    } else if (!prevProps.printPreview && this.props.printPreview) {
      this.openPrintPreview()
    }
  }

  /**
   * Updates the placement proposal
   * @param {Object} placement - Placement object
   * @returns {void}
  */ 
  updatePlacementProposal = (placement) => {
    this.setState({ spinnerCount: 1});
    let payload = {
      "Proposals": [
        {
            "id": placement.id,
            "placements_id": placement.placements_id,
            "is_proposed": placement.is_proposed === "true" ? "false" : "true"
        }
      ]
    }
    
    let campaignId = encodeURIComponent(this.props.campaignObj.id);
    RfpService.updateProposal(campaignId, this.props.rfp.id, payload).then((response) => {
      this.fetchProposalDetails(this.props.rfp.id, 'Selected placement proposal updated successfully.');
    }).catch((error) => {
      AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.updatePlacementProposal(placement), title: 'Unable to update the placement proposal', bodyMsgArr: []}]);
      this.setState({ spinnerCount: 0});
    }).finally(()=>{
      this.setState({ loading: false});
    })
  }

  /**
   * Updates all the proposals for the placements
   * @returns {void}
   */
  updateAllProposals = () => {
    this.setState({ spinnerCount: 1});
    let payload = {"Proposals": []};
    for(let i=0;i<this.placementList.length;i++){
      payload.Proposals.push({
        "id": this.placementList[i].id,
        "placements_id": this.placementList[i].placements_id,
        "is_proposed": this.state.isProposeAll
      })
    }
    let campaignId = encodeURIComponent(this.props.campaignObj.id);
    RfpService.updateProposal(campaignId, this.props.rfp.id, payload).then((response) => {
      this.setState({isProposeAll: !this.state.isProposeAll});
      this.fetchProposalDetails(this.props.rfp.id, 'All placement proposals updated successfully.');
    }).catch((error) => {
      AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: this.updateAllProposals, title: 'Unable to update all the placement proposals', bodyMsgArr: []}]);
      this.setState({ spinnerCount: 0});
    }).finally(()=>{
      this.setState({ loading: false});
    })
  }

  /**
   * Redirects to the placement details page
   * @returns {void}
  */ 
  redirectToPlacement = () => {
    Utils.navigateToComponent(this.props.campaignObj, 'placementDetailsTable', this.props);
  }

  /**
   * This method is used to apply the filter
   * @param {Object} filter - Filter object
   * @returns {void}
  */
  applyFilter = (filter) => {

  }

  /**
   * Returns the package icon based on the parent_id
   * @param {Object} value - Placement object
   * @returns {Object} - Icon element
   */
  getPackageIcon = (value) => {
    if (!value?.parent_id && value?.id) {
        return html`<omni-icon part="package-icon margin-left-10" class="is-size-4 cursor" icon-id="omni:informative:package"></omni-icon>`
    } else if (value?.parent_id && value?.id) {
        return html`<omni-icon part="package-icon package-child-icon margin-left-20" class="is-size-4 cursor" icon-id="omni:informative:package"></omni-icon>`
    }
  }

  /**
    * Attaches a file upload event handler to a file input element.
    * When a file is selected, it triggers the import function.
  */
  addFileUploadEventHandler = () => {
    const fileInput = document.getElementById('proposalFileInput');

    fileInput.addEventListener("click", (event) => {
      event.stopImmediatePropagation();
      fileInput.value = null;
    });

    fileInput.addEventListener("change", (event) => {
      event.stopImmediatePropagation();
      const file = fileInput.files[0];
      const reader = new FileReader();
      reader.onload = (event) => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, {
          type: "array",
          cellDates: true,
          dateNF: "yyyy-mm-dd",
        });
        let payload = {"Proposals": []};
        /* Loop through each sheet in the workbook and set in the payload */
        for (let sheetName of workbook.SheetNames) {
          let worksheet = workbook.Sheets[sheetName];
          let sheetRows = XLSX.utils.sheet_to_json(worksheet, {raw: false});
          let rowsHavingTaxonomy = sheetRows.filter((row)=> row['placement_taxonomy']);
          for(let i=0;i<rowsHavingTaxonomy.length;i++){
            let proposalObj = {
                "packageType": 'Standalone',
                "placementCost": {
                  "plannedCost": {"amount": rowsHavingTaxonomy[i].planned_cost ? rowsHavingTaxonomy[i].planned_cost : "0"},
                  "rate": {"amount": rowsHavingTaxonomy[i].rate ? rowsHavingTaxonomy[i].rate : "0"},
                  "unitAmount": rowsHavingTaxonomy[i].unit_amount ? rowsHavingTaxonomy[i].unit_amount : "0"
                },
                "placementTaxonomy": rowsHavingTaxonomy[i].placement_taxonomy ? rowsHavingTaxonomy[i].placement_taxonomy : "",
                "placementTaxonomyDisplay": rowsHavingTaxonomy[i].placement_taxonomy_display ? rowsHavingTaxonomy[i].placement_taxonomy_display : "",
                "overridenPlacementTaxonomy": rowsHavingTaxonomy[i].overriden_placement_taxonomy ? rowsHavingTaxonomy[i].overriden_placement_taxonomy : "",
                "overridenPlacementTaxonomyDisplay": rowsHavingTaxonomy[i].overriden_placement_display_taxonomy ? rowsHavingTaxonomy[i].overriden_placement_display_taxonomy : "",
                "taxonomySchema": rowsHavingTaxonomy[i].taxonomy_schema ? rowsHavingTaxonomy[i].taxonomy_schema : "",
                "placementType": rowsHavingTaxonomy[i].placement_type ? rowsHavingTaxonomy[i].placement_type : "",
                "buyCategory": rowsHavingTaxonomy[i].buy_category ? rowsHavingTaxonomy[i].buy_category : "",
                "unitType": rowsHavingTaxonomy[i].unit_type ? rowsHavingTaxonomy[i].unit_type : "",
                "costMethod": rowsHavingTaxonomy[i].cost_method ? rowsHavingTaxonomy[i].cost_method : "",
                "site": rowsHavingTaxonomy[i].site ? rowsHavingTaxonomy[i].site : "",
                "supplierCode": rowsHavingTaxonomy[i].supplier_code ? rowsHavingTaxonomy[i].supplier_code : "",
                "dimensionsPosition": rowsHavingTaxonomy[i].dimensions_position ? rowsHavingTaxonomy[i].dimensions_position : "",
                "dimensions": rowsHavingTaxonomy[i].dimensions ? rowsHavingTaxonomy[i].dimensions : "",
                "flightStart": rowsHavingTaxonomy[i].flight_start ? rowsHavingTaxonomy[i].flight_start : "",
                "flightEnd": rowsHavingTaxonomy[i].flight_end ? rowsHavingTaxonomy[i].flight_end : "",
                "primaryPlacement": false,
                "marketValue": "",
                "overrideTaxonomy": false,
                "parameterCode": rowsHavingTaxonomy[i].parameter_code ? rowsHavingTaxonomy[i].parameter_code : "",
                "parameterCodeTaxonomyDisplay": rowsHavingTaxonomy[i].parameter_code_taxonomy_display ? rowsHavingTaxonomy[i].parameter_code_taxonomy_display : "",
                "parameterCodeTaxonomySchema": rowsHavingTaxonomy[i].parameter_code_taxonomy_schema ? rowsHavingTaxonomy[i].parameter_code_taxonomy_schema : "",
                "parentId": null,
                "ad_verification": rowsHavingTaxonomy[i].ad_verification ? rowsHavingTaxonomy[i].ad_verification : "",
                "is_approved": false,
                "parameter_code_taxonomy_display": rowsHavingTaxonomy[i].parameter_code_taxonomy_display ? rowsHavingTaxonomy[i].parameter_code_taxonomy_display : "",
                "parameter_code_taxonomy_schema": rowsHavingTaxonomy[i].parameter_code_taxonomy_schema ? rowsHavingTaxonomy[i].parameter_code_taxonomy_schema : "",
                "vendor_datasource_id": rowsHavingTaxonomy[i].vendor_datasource_id ? rowsHavingTaxonomy[i].vendor_datasource_id : "",
                "datasource": "RFP",
                "supplier_code": rowsHavingTaxonomy[i].supplier_code ? rowsHavingTaxonomy[i].supplier_code : "",
                "is_proposed": false
            }
            payload.Proposals.push(proposalObj);
          }
        }
        this.setState({spinnerCount: 1});
        let campaignId = encodeURIComponent(this.props.campaignObj.id);
        RfpService.addProposalsDetails(campaignId, this.props.rfp.id, payload).then((response) => {
            this.fetchProposalDetails(this.props.rfp.id, 'Proposals have been imported successfully');
        })
        .catch((err) => {
            AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: this.addFileUploadEventHandler, title: 'Unable to import the proposals', bodyMsgArr: []}]);
            this.setState({spinnerCount: 0});
        });
      };
      reader.readAsArrayBuffer(file);
    });
  };

  /**
   * The below function is a event handler attached to the Import/Export taxonomy option in the taxonomy table.
   * It will do the export of the RFP proposal table data on click of the export option & call the import event handler on click of the import option
   * @function importExportClick
   * @param {object} event - event object
   * @returns {void}
   */
  importExportClick = (event) => {
    const label = event?.detail?.value?.label;
    if (label.includes('Export')) {
        this.setState({ spinnerCount: 1 });
        // Call the RatesAndFeesService to export rate and fee data
        RfpService.getProposalsDetails(this.props.campaignObj.id, this.props.rfp.id)
            .then((response) => {
                AlertMessagesService.showSuccessToastMessage('Proposals exported successfully!');
                // Export the data to an Excel file using the utils function
                Utils.exportToExcel(response, 'Proposals', `${this.props.rfp.rfp_name}_Proposals.xlsx`);
                this.setState({ spinnerCount: 0 });
            }, (error) => {
                AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.importExportClick(event), title: 'Unable to export the proposals', bodyMsgArr: []}]);
                this.setState({ spinnerCount: 0 });
            });
    } else if (label.includes('Import')) {
        // Trigger a click event on the file input element to initiate file selection
        document.getElementById('proposalFileInput').click();
    }
  }

  placementLeftColumns = [
    {
      label: 'PLACEMENT NAME',
      key: 'placement_taxonomy',
      sortable: true,
      passthrough: true,
      template: (value, index) => {
        return html`
          <style>
            :host::part(packageNameWithIcon){
              display: flex;
              gap: 20px;
            }

            :host::part(package-icon) {
              width: 18px;
              height: 18px;
              top: 3px;
              position: relative;
              --color-icon-lines: #00A1D2;
            }

            :host::part(margin-left-20) {
              margin-left: 20px;
            }
            
            :host::part(margin-left-10) {
              margin-left: 10px;
            }
            .expand-wrapper.is-clamped {
              max-width: 100% !important;
            }
          </style>
          <div part="table-body-cell packageNameWithIcon">
            ${this.getPackageIcon(value)}
            <span>${value.placement_taxonomy}</span>
          </div>`
        }
    },
    {
      label: 'Type',
      key: 'package_type',
      default: '',
      isSortable: false,
      passthrough: true,
      template: (value, index) => {
        const dataValue = value.package_type === 'DSP' ? 'Line Item' : value.package_type
        return html`<td part="table-body-cell">
              ${dataValue}
          </td>`
      }
    },
    {
      label: 'NET MEDIA',
      key: 'planend_budget',
      sortable: true
    },
    {
      label: 'AD SERVING FEE',
      key: 'adServingBudget',
      sortable: true,
      passthrough: true,
      template: (value, index) => {
        const displayValue = value?.adServingBudget ? `${(value?.adServingBudget)?.toLocaleString('en-US', { style: "currency", currency: "USD" })}` : '';
        return html`<td part="table-body-cell ad-fee">
            ${displayValue}
        </td>`
      }
    },
    {
      label: 'AD VERIFICATION FEE',
      key: 'adVerifiactionBudget',
      sortable: true,
      passthrough: true,
      template: (value, index) => {
        const displayValue = value.adVerifiactionBudget ? `${(value?.adVerifiactionBudget)?.toLocaleString('en-US', { style: "currency", currency: "USD" })}` : '';
        return html`<td part="table-body-cell ad-fee">
            ${displayValue}
        </td>`
      }
    },
    {
      label: 'RATE',
      key: 'rate',
      sortable: true,
      passthrough: true,
      template: (value, index) => {
        return html`<td part="table-body-cell">
            ${PlacementDetailsTableService.getRate(value)}
        </td>`
      }
    },
    {
      label: 'UNITS',
      key: 'unit_amount',
      sortable: true,
      passthrough: true,
      template: (value, index) => {
        value.unit_amount = Array.isArray(value.unit_amount) ? value.unit_amount[0] : value.unit_amount;
        return html`<td part="table-body-cell">
            ${PlacementDetailsTableService.getUnits(value, index)}
        </td>`
      }
    },
    {
      label: 'TOTAL',
      key: 'planned_cost',
      sortable: true,
      passthrough: true,
      template: (value, index) => {
        value.planned_cost = Array.isArray(value.planned_cost) ? value.planned_cost[0] : value.planned_cost;
        return html`<td part="table-body-cell">
          <p>
            ${PlacementDetailsTableService.getPlannedCost(value, index)}
          </p>
        </td>`;
      }
    },
    {
      label: 'START DATE',
      key: 'flight_start',
      sortable: true,
      passthrough: true,
      template: (value, index) => {
        return html`<td part="table-body-cell">
         ${Utils.formatDateObject(value.flight_start ? value.flight_start : '')}
         </td>`
      }
    },
    {
      label: 'END DATE',
      key: 'flight_end',
      sortable: true,
      passthrough: true,
      template: (value, index) => {
        return html`<td part="table-body-cell">
         ${Utils.formatDateObject(value.flight_end ? value.flight_end : '')}
         </td>`
      }
    }
  ];

  placementRightColumns = [
    {
      label: 'ACTION',
      key: 'actions',
      passthrough: true,
      template: (value, index) => {
        if (value?.id) {
          return html`
            <style>
              :host::part(action-cell){
                padding-left: 10px;
              }
              :host::part(restore-button){
                  font-size: 14px !important;
                  padding: 10px 24px 10px 24px !important;
                  line-height: 14px !important;
                  height: 30px !important;
              }                
            </style>
            <td part="table-body-cell action-cell">
              <div style="display: flex;">
                <button part="restore-button" class="button is-outlined is-medium" @click="${() => this.updatePlacementProposal(value)}">
                  ${value.is_proposed === "true" ? 'Unpropose' : 'Propose'}
                </button>
              </div>
            </td>`;
        } else {
          return html`<td part="table-body-cell"></td>`;
        }
      }
    }
  ]

  render() {
    const { rfp } = this.state;
    return (
      <OmniStyleComponent>
        {this.props.isRfpPreviewOpen && (
          <div className='rfp-preview-container modal is-active' ref={this.modalRef}>
            <div className='modal-content'>
              <LoaderComponent
                spinnerCount={this.state.spinnerCount}
                displayWholePage={true}
              />
              <article className='message'>
                <div>
                  <div className='message-header'>
                    <p className='object-title is-size-3'>RFP Preview</p>
                    <button className='no-print button is-outlined is-medium' onClick={this.openPrintPreview}>Print</button>
                    <OmniIconComponent
                      className='is-size-4 closeIcon'
                      icon-id='omni:interactive:close'
                      onClick={this.props.closePreviewModal}
                    ></OmniIconComponent>
                  </div>
                  {this.state.loading ? (
                    <></>
                  ) : (
                    <>
                      <div className='rfp-preview-section'>
                        <div className='col'>
                          <div className='label'>RFP name</div>
                          <div className='value'>{rfp.rfp_name}</div>
                        </div>
                        <div className='col span-three'>
                          <div className='label'>Contact emails(s)</div>
                          <div className='value'>{rfp.recipients}</div>
                        </div>
                      </div>
                      <AccordionComponent accordion={{ header: 'Budget and dates', isOpen: true }}>
                        <div className='rfp-preview-section'>
                          <div className='col'>
                            <div className='label'>Budget 1</div>
                            <div className='value'>
                              {Utils.numberToCurrencyString(rfp.budget1)}
                            </div>
                          </div>
                          <div className='col'>
                            <div className='label'>Budget 2</div>
                            <div className='value'>
                              {Utils.numberToCurrencyString(rfp.budget2)}
                            </div>
                          </div>
                          <div className='col'>
                            <div className='label'>Budget 3</div>
                            <div className='value'>
                              {Utils.numberToCurrencyString(rfp.budget3)}
                            </div>
                          </div>
                          <div className='col'>
                            <div className='label'>Include Flighting?</div>
                            <div className='value'>
                              {rfp.include_flighting ? 'Yes' : 'No'}
                            </div>
                          </div>
                          <div className='col'>
                            <div className='label'>Campaign start date</div>
                            <div className='value'>
                              {Utils.formatCalenderDate(rfp.start_date)}
                            </div>
                          </div>
                          <div className='col'>
                            <div className='label'>Campaign end date</div>
                            <div className='value'>
                              {Utils.formatCalenderDate(rfp.end_date)}
                            </div>
                          </div>
                          <div className='col'>
                            <div className='label'>Provider</div>
                            <div className='value'>{rfp.provider_id}</div>
                          </div>
                          <div className='col'>
                            <div className='label'>Financial supplier</div>
                            <div className='value'>
                              {rfp.financial_supplier}
                            </div>
                          </div>
                        </div>
                      </AccordionComponent>
                      <AccordionComponent accordion={{ header: 'Strategy and media', isOpen: true }}>
                        <div className='rfp-preview-section'>
                          <div className='col'>
                            <div className='label'>Strategy</div>
                            <div className='value'>{rfp.strategy}</div>
                          </div>
                          <div className='col'>
                            <div className='label'>Media</div>
                            <div className='value'>{rfp.media}</div>
                          </div>
                          <div className='col'>
                            <div className='label'>Due date</div>
                            <div className='value'>
                              {Utils.formatCalenderDate(rfp.response_due_date)}
                            </div>
                          </div>
                          <div className='col'>
                            <div className='label'>Comments</div>
                            <div className='value'>{rfp.comments}</div>
                          </div>
                        </div>
                      </AccordionComponent>
                      <AccordionComponent accordion={{ header: 'Placements and package details', isOpen: true }}>
                        <div className='rfp-proposal-section'>
                        <input type="file" id="proposalFileInput" accept=".xlsx, .xls" hidden />
                        {this.state.proposals.length === 0 ? <div className='noData'>No data found</div> : (
                          <>
                            <OmniTileComponent heading="" className='propsal-table-header'>
                              <OmniToolbarComponent slot="header">
                                <label slot="start">Placements Details</label>
                                <div slot="end" className="custom-dropdown-menu">
                                  <button className="button is-medium is-outlined" onClick={()=> this.updateAllProposals()}>
                                    {this.state.isProposeAll ? 'Propose all' : "Unpropose all"}
                                  </button>
                                </div>
                                <div slot="end" className="custom-dropdown-menu">
                                  <OmniIconMenu
                                        options={["Import data", "Export data"]}
                                        iconId="omni:interactive:importExport"
                                        iconClass="is-size-4"
                                        tooltip="Import/Export"
                                        onDropdownChange={(event) => this.importExportClick(event)}>
                                  </OmniIconMenu>
                                  <div className="Line-Copy-2"></div>
                                  <OmniSearchComponent className="search-input-icon" slot="end" ph="Search"></OmniSearchComponent>
                                  <div className="Line-Copy-2"></div>
                                </div>
                                <div slot="end" className="custom-dropdown-menu">
                                  <div className='filter-menu'>
                                    <div className="separater-vertical"></div>
                                    <button  slot="invoker" aria-haspopup="true" className='button is-text is-shadowless' disabled> 
                                      <OmniIconComponent slot="end" className="menu-trigger is-size-2 has-text-almost-black" icon-id="omni:interactive:filter"></OmniIconComponent> 
                                    </button>
                                    {/* <PlacementFilterComponent onApplyFilter={this.applyFilter.bind(this)}/> */}
                                  </div>
                                </div>
                              </OmniToolbarComponent>
                            </OmniTileComponent>
                            <OmniTableStickyComponent
                              id="proposal-table"
                              keyFn={row => row && row._uniqueId}
                              key={this.state.proposals.length}
                              leftColumns={this.placementLeftColumns}
                              rightColumns={this.placementRightColumns}
                              data={this.state.proposals}
                              expandAllOnLoad={true}
                            >
                            </OmniTableStickyComponent>
                          </>
                        )}
                        </div>
                      </AccordionComponent>
                      <div className='footer-section'>
                        <button className='button is-shadowless is-text' onClick={this.props.closePreviewModal}>Cancel</button>
                        <button className='button is-primary save-edit-button' onClick={this.redirectToPlacement}>Open proposed budget</button>
                      </div>
                    </>
                  )}
                </div>
              </article>
            </div>
          </div>
        )}
      </OmniStyleComponent>
    );
  }
}

export default RfpPreview;
